type RouterSessionHandlers = {
  getCurrentFullPath: () => string
  isLoginPath: () => boolean
  replaceToLogin: (redirect: string) => Promise<void>
}

let handlers: RouterSessionHandlers | undefined

export function wireRouterSessionHandlers(next: RouterSessionHandlers): void {
  handlers = next
}

export async function redirectToLoginAfterSessionExpiry(): Promise<void> {
  if (!handlers || handlers.isLoginPath()) {
    return
  }

  await handlers.replaceToLogin(handlers.getCurrentFullPath())
}
